import CustomKMPlus from '@public/icons/km_plus_new.svg';
import React, { SVGProps } from 'react';

type CustomKMPlusWrapperProps = SVGProps<SVGSVGElement>;
const CustomKMPlusWrapper: React.FC<CustomKMPlusWrapperProps> = (props) => {
  return <CustomKMPlus {...props} />;
};

export default CustomKMPlusWrapper;
